import React from 'react';

// Components
import ConfigBuilderWrapper from '../../config-builder-wrapper/config-builder-wrapper';

// CSS
import './results-header.less';

interface ResultsHeaderProps {
  config?: any[];
  data: Record<string, any>;
  onChange: (config: any, value: any) => void;
  onBlur?: () => void;
  customComponents?: Record<string, any>;
}

export const ResultsHeader: React.FC<ResultsHeaderProps> = (props) => {
  const { customComponents, data, onChange, onBlur, config } = props;

  const configBuilderProps = {
    customComponents,
    data,
    onChange,
    onBlur,
  };

  return (
    <div className="results-header">
      <div className="results-header-inputs">
        {config.map((inputConfig, index) => (
          <ConfigBuilderWrapper
            {...configBuilderProps}
            viewConfig={inputConfig}
            key={`results-header-input-${index}`}
          />
        ))}
      </div>
    </div>
  );
};

ResultsHeader.defaultProps = {
  config: [],
  onBlur: () => {},
  customComponents: {},
};

export default ResultsHeader;
